<template>
  <div class="conversation-list-container  d-flex flex-column row-gap-8">
    <el-dialog title="Gửi yêu cầu kết bạn" :visible.sync="friendBoxVisible" :close-on-click-modal="false" width="30%"
               destroy-on-close>
      <SendFriendRequest :friend="friendSearch" />
    </el-dialog>
    <el-dialog width="700px" title="Tìm kiếm liên hệ" :visible.sync="searchNewContactVisible"
               :close-on-click-modal="false" destroy-on-close>
      <SearchNewContact />
    </el-dialog>
    <div class="d-flex p-2">
      <h3 class="pt-1 fw-bold font-size-16">Tin nhắn</h3>
      <div class="d-flex flex-1 justify-content-end align-self-end ">
        <el-select v-model="selectAccountId" @change="changeAccount" filterable default-first-option
                   placeholder="Tìm kiếm tài khoản..." size="mini">
          <el-option label="Tất cả tài khoản"
                     :value="''"></el-option>
          <el-option v-for="account in accounts" :key="account.accountId" :label="getAccountName(account)"
                     :value="account.accountId">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="d-flex px-2 py-1">
      <el-input size="small" ref="inputMesage" @input="searchKeyChanged" v-model="filter.searchKey"
                placeholder="Tìm kiếm"
                @keydown.enter.exact.native="fetchConversationList()"></el-input>
      <el-tooltip effect="dark" content="Thêm liên hệ" placement="top">
        <div class="conversation-list-search-icon pointer d-flex justify-content-center mx-1"
             @click="searchNewContact()">
          <img class="ic-img font-icon-16" src="/assets/icon/add_contact_icon.svg" />
        </div>
      </el-tooltip>
    </div>
    <div class="d-flex justify-content-between ps-2">
      <div class="flex-1 p-1 pointer mx-1 d-flex  justify-content-center align-items-center rounded"
           v-bind:style="checkFilter(item.text) ? 'background-color: rgba(31,105,199,.28)' : ''"
           v-for="(item) in filterMessages" :key="item.key">
        <el-tooltip effect="dark" :content="item.text" placement="top">
          <i class="pointer d-flex  justify-content-center align-items-center " @click="selectFilter(item.text)">
            <img :src="item.src" class="font-icon-16" alt="" />
          </i>
        </el-tooltip>
      </div>
      <div class="flex-1 p-1 pointer mx-1 d-flex justify-content-center align-items-center rounded"
           v-bind:style="checkFilterGroup(item.text) ? 'background-color: rgba(31,105,199,.28)' : ''"
           v-for="(item) in filterGroup" :key="item.key">
        <el-tooltip effect="dark" :content="item.text" placement="top">
          <i class=" d-flex  justify-content-center align-items-center pointer" @click="selectFilterGroup(item.text)">
            <img :src="item.src" class="mx-2 font-icon-16" alt="" />
          </i>
        </el-tooltip>
      </div>
      <div class="flex-1 p-1 pointer mx-1 d-flex justify-content-center align-items-center rounded"
           v-bind:style="filterEnabledTag() ?'background-color: rgba(31,105,199,.28)':''">
        <el-popover placement="bottom" trigger="click">
          <div class="conversation-box-popover">
            <div class="mb-3 font-size-16 d-flex ">
              <div class="flex-grow-1">Lọc theo tag</div>
              <el-tooltip class="item pointer mx-1" effect="dark" content="Xóa bộ lọc"
                          placement="top" v-if="filterEnabledTag()">
                <i class="icon-close-fill text-danger item fw-bold font-size-16 mx-1" @click="clearTag"
                />
              </el-tooltip>
            </div>
            <div class="d-flex flex-wrap text-center overflow-auto" style="max-width: 400px;max-height:300px">
              <div v-for="(tag, index) in app.tags" :key="index">
                <div class="d-flex pointer" @click="selectTag(tag.id)">
                  <div style="margin: 2px">
                    <Tag :item="tag" :selected="selectedTag(tag.id)" :is-button="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <el-tooltip slot="reference" effect="dark" content="Lọc theo tag" placement="top">
            <img class="ic-img pointer font-icon-16" src="/assets/icon/ic_tag_filter.svg" />
          </el-tooltip>
        </el-popover>
      </div>
      <div class="flex-1 p-1 pointer mx-1 d-flex justify-content-center align-items-center rounded"
           v-bind:style="filterEnableCalender() ? 'background-color: rgba(31,105,199,.28)' : ''">
        <el-popover placement="bottom" trigger="click">
          <div>
            <el-date-picker v-model="filter.dateRange" size="small" type="daterange" range-separator="-"
                            start-placeholder="Ngày bắt đầu" end-placeholder="Ngày kết thúc"
                            :default-time="['00:00:00', '23:59:59']"
                            @change="fetchConversationList()"></el-date-picker>
          </div>
          <el-tooltip slot="reference" class="item mx-1 pointer d-flex  justify-content-center align-items-center"
                      effect="dark" content="Lọc theo thời gian" placement="top">
            <img src="/assets/icon/ic_time.svg" class="mx-2 " style="max-width: 12px;max-height:12px" />
          </el-tooltip>
        </el-popover>
      </div>
      <div class="flex-1 p-1 mx-1 pointer d-flex align-items-center justify-content-center">
        <el-tooltip slot="reference" effect="dark" content="Xoá bộ lọc" placement="top">
          <img v-if="!filterEnabled()" style="max-width: 14px;max-height: 14px" src="/assets/icon/icon_close.svg" />
          <img v-else @click="removeFilter()" style="max-width: 14px;max-height: 14px"
               src="/assets/icon/icon_close_fill.svg" /></el-tooltip>

      </div>
    </div>

    <div class="pt-1 divider-custom-zalo" />
    <div v-if="!showSearchArea">
      <div style="  height: calc(100vh - 125px)" data-simplebar="init">
        <div class="simplebar-wrapper" style="margin: 0px;">
          <div class="simplebar-height-auto-observer-wrapper">
            <div class="simplebar-height-auto-observer"></div>
          </div>
          <div class="simplebar-mask">
            <div class="simplebar-offset" style="right: -15px; bottom: 0px;">
              <div class="simplebar-content-wrapper-conversation-zalo" style="height: 100%">
                <div v-loading="loading" class="simplebar-content-wrapper-conversation" style="height: 100%">
                  <div class="simplebar-content" style="padding: 0px;">
                    <ul class="list-unstyled chat-list chat-user-list" style="border-radius: 1px !important;">
                      <li class="unread" v-for="(conversation, index) in app.pinConversationView"
                          :key="index + conversation.id + '1'" @click="selectConversation(conversation)"
                          v-bind:class="selectedCon.id === conversation.id ? 'active' : ''">
                        <ConversationItem :accounts="accounts" :conversation="conversation"
                                          v-if="!conversation.hidden" />
                      </li>
                      <li class="unread" v-for="(conversation, index) in viewConversations"
                          :key="index + conversation.id + '0'" @click="selectConversation(conversation)"
                          v-bind:class="selectedCon.id === conversation.id ? 'active' : ''">
                        <ConversationItem :accounts="accounts" :conversation="conversation"
                                          v-if="showCon(conversation)" />
                      </li>
                      <scroll-loader v-if="hasLoadMore" :loader-method="loadMoreConversations"
                                     :loader-disable="noMoreConversation">
                        <div style="margin-right: 16px" v-loading="true"></div>
                      </scroll-loader>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="d-flex flex-column">
      <div v-if="historySearch.length" class="d-flex flex-column gap-3 mt-2">
        <span class="fw-semibold fs-6">Tìm kiếm gần đây</span>

        <div class="d-flex align-items-center" v-for="item in historySearch" :key="item.uid">
          <div class="d-flex align-items-center gap-3">
            <el-avatar :src="item.avatar || 'assets/images/no-avatar.png'"></el-avatar>

            <div class="d-flex flex-column">
              <span class="fw-bold">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="friendSearch.uid" class="d-flex flex-column gap-3 mt-2">
        <span class="fw-semibold fs-6">Tìm bạn qua số điện thoại</span>

        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center w-100 gap-3">
            <el-avatar :src="friendSearch.avatar || 'assets/images/no-avatar.png'"></el-avatar>

            <div class="flex-1 d-flex flex-column">
              <span class="fw-bold">{{ friendSearch.display_name }}</span>
              <span>
                S? di?n tho?i:
                <span class="text-primary ">{{ friendSearch.phone }}</span>
              </span>
            </div>

            <el-button type="primary" round size="mini" @click="openFriendBox(friendSearch)">Kết bạn</el-button>
          </div>
        </div>
      </div>

      <span class="fw-semibold fs-6" v-if="conversationSearch.length">Tin nhắn</span>
    </div>
  </div>
</template>

<script>
import dateUtil from "../lib/date-util";
import Tag from "@/components/common/TagCustom";
import SendFriendRequest from "@/components/SendFriendRequest";
import ConversationItem from "@/components/common/ConversationItem";
import SearchNewContact from "@/components/contact/SearchNewContact";

export default {
  props: ["accounts"],
  components: {
    SearchNewContact,
    ConversationItem,
    Tag,
    SendFriendRequest

  },
  data() {
    return {
      hasLoadMore: false,
      // filterMessages: ["Chưa đọc", "Chưa trả lời"],
      filterMessages: [{
        text: "Chưa đọc", src: "/assets/icon/eye.svg", key: "UNREAD"
      }, { text: "Chưa trả lời", src: "/assets/icon/icon_unrep.svg", key: "UNREPLIED" }],

      // filterGroup: ["Nhóm", "Cá nhân"],
      filterGroup: [{
        text: "Nhóm", src: "/assets/icon/alone.svg", key: "GROUP"
      }, { text: "Cá nhân", src: "/assets/icon/icon_user.svg", key: "INDIVIDUAL" }],

      selectAccountId: "",
      filter: {
        searchKey: "",
        selectedAccountIds: [],
        lastMessageTime: 0,
        selectedTags: [],
        dateRange: [],
        filterMessage: "",
        filterGroup: null,
        unReplied: null
      },
      loading: false,
      conversations: [],
      viewConversations: [],
      showSearchArea: false,
      historySearch: [],
      friendSearch: {},
      conversationSearch: [],
      noMoreConversation: true,
      friendBoxVisible: false,
      searchNewContactVisible: false,
      friendUid: 0,
      selectedCon: { id: { accountId: "", toId: "" } },
      PAGE_SIZE: 30
    };
  },
  methods: {
    showCon(con) {
      let filter = this.app.pinConversationView.filter(t => t.id == con.id);
      if (filter && filter.length > 0) return false;
      return true;
    },
    showTag(id) {
      let filter = this.app.tags.filter(t => t.id == id);
      if (filter && filter.length > 0) return true;
      return false;
    },
    filterEnableCalender() {
      if (this.filter.dateRange === null) return false;
      return this.filter.dateRange.length > 0;
    },
    filterEnabledTag() {
      return this.filter.selectedTags.length > 0;
    },
    getAvatar(conversation) {
      if (conversation.avatar) {
        return conversation.avatar;
      } else {
        return "/assets/images/no-avatar.png";
      }
    },
    changeAccount() {
      this.removeFilter();
    },
    searchKeyChanged() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.fetchConversationList();
      }, 700);
    },
    checkFilterGroup(filter) {
      if (this.filter.filterGroup == filter) return true;
      return false;
    },
    selectFilterGroup(filter) {
      if (this.filter.filterGroup === filter) {
        this.filter.filterGroup = null;
      } else {
        this.filter.filterGroup = filter;
      }
      this.fetchConversationList();
    },

    checkFilter(filter) {
      if (this.filter.filterMessage == filter) return true;
      return false;
    },
    selectFilter(filter) {
      if (this.filter.filterMessage === filter) {
        this.filter.filterMessage = "";
      } else {
        this.filter.filterMessage = filter;
      }
      this.fetchConversationList();
    },
    clearTag() {
      this.filter.selectedTags = [];
      this.fetchConversationList();
    },
    selectTag(tagId) {
      let indexOf = this.filter.selectedTags.indexOf(tagId);
      if (indexOf > -1) {
        this.filter.selectedTags.splice(indexOf, 1);
      } else {
        this.filter.selectedTags.push(tagId);
      }
      this.fetchConversationList();

    },

    selectedTag(tagId) {
      let indexOf = this.filter.selectedTags.indexOf(tagId);
      if (indexOf > -1) {
        return true;
      }
      return false;
    },
    checkSelectedAccount(accountId) {
      let acc = this.filter.selectedAccountIds.filter(p => p === accountId);
      return acc != null && acc.length > 0;
    },
    selectAccount(accountId) {
      let indexOf = this.filter.selectedAccountIds.indexOf(accountId);
      if (indexOf > -1) {
        this.filter.selectedAccountIds.splice(indexOf, 1);
      } else {
        this.filter.selectedAccountIds.push(accountId);
      }
      this.fetchConversationList();
    },
    unSelectAccount() {
      this.filter.selectedAccountIds = [];
      this.fetchConversationList();
    },
    removeFilter() {
      this.filter = {
        filterMessage: "",
        searchKey: "",
        selectedAccountIds: [],
        lastMessageTime: 0,
        selectedTags: [],
        dateRange: [],
        filterGroup: null
      };
      this.filter.selectedAccountIds = this.selectAccountId.length > 0 ? [this.selectAccountId] : [];
      this.fetchConversationList();
    },
    filterEnabled() {
      return (
        this.filter.filterGroup !== null ||
        this.filter.filterMessage !== "" ||
        this.filter.searchKey !== "" ||
        // this.filter.selectedAccountIds.length > 0 ||
        this.filter.selectedTags.length > 0 ||
        (this.filter.dateRange != null && this.filter.dateRange.length == 2)
      );
    },

    getTimeToStamp(dateRange) {
      let arrDate = [];
      if (dateRange.length > 0) {
        dateRange.forEach((s) => {
            arrDate.push(new Date(s).getTime());
          }
        );
        return arrDate;
      }
      return [];
    },
    isGroup(filterGroup) {
      if (filterGroup === "Nhóm") return true;
      if (filterGroup === "Cá nhân") return false;
      return null;
    },

    async fetchConversationList(loadMore = false) {
      let request = {
        isGroup: this.isGroup(this.filter.filterGroup),
        unread: this.filter.filterMessage === "Chưa đọc",
        unReplied: this.filter.filterMessage === "Chưa trả lời" ? true : null,
        searchKey: this.filter.searchKey,
        accountIds: this.filter.selectedAccountIds,
        lastMessageTime: loadMore ? this.filter.lastMessageTime : 0,
        selectedTags: this.filter.selectedTags,
        dateRange: this.getTimeToStamp(this.filter.dateRange),
        pageSize: this.PAGE_SIZE
      };
      this.loading = true;
      this.$http.post("/api/conversation", request)
        .then(resp => {
          this.conversations = loadMore ? this.conversations.concat(resp.data) : resp.data;
          this.noMoreConversation = resp.data.length < this.PAGE_SIZE || (this.filter.searchKey != null && this.filter.searchKey.length > 0);
          this.sortConversation();
        })
        .finally(() => this.loading = false);
    },

    loadMoreConversations() {
      if (this.conversations.length > 0) {
        this.filter.lastMessageTime = this.conversations[this.conversations.length - 1].lastMessageTime;
        this.fetchConversationList(true);
      }
    },
    lastMessageTime(time) {
      return dateUtil.timestampToDate(time);
    },
    getName(accountId) {

      let filter = this.accounts.filter(a => a.accountId == accountId);
      if (filter && filter.length > 0) {
        return this.getAccountName(filter[0]);
      }
      return "";
    },
    getAccountAvatar(accountId) {
      let filter = this.accounts.filter(a => a.accountId == accountId);
      if (filter && filter.length > 0) {
        return filter[0].avatar;
      }
      return "";
      // return this.accounts.find(a => a.accountId == accountId).avatar;
    },
    selectConversation(conversation) {
      this.selectedCon = conversation;
      this.$emit("selected", conversation);
    },
    updateConversation(conversation) {

      var date = new Date(conversation.lastMessageTime);
      var now = this.conversations.length > 0 ? new Date(this.conversations[this.conversations.length - 1].lastMessageTime) : new Date();
      const diffTime = date - now;
      if (diffTime >= 0) {
        var index = this.conversations.findIndex(csv => {
          return csv.id === conversation.id;
        });

        if (index >= 0) {
          this.conversations.splice(index, 1);
        }
        if (conversation.id === this.selectedCon.id) {
          conversation.unreadCount = 0;
        }
        this.conversations.unshift(conversation);
        this.conversations.sort((a, b) => b.lastMessageTime - a.lastMessageTime);
        this.sortConversation();
      }

    },
    updateConversationPin(conversation) {
      var index = this.app.pinConversationView.findIndex(csv => {
        return csv.id === conversation.id;
      });

      if (index >= 0) {
        this.app.pinConversationView.splice(index, 1);
        if (conversation.id === this.selectedCon.id) {
          conversation.unreadCount = 0;
        }
        conversation.isPin = true;
        this.app.pinConversationView.unshift(conversation);
      }

    },
    tagConversation(data) {
      this.conversations.forEach(conv => {
        if (conv.id == data.id) {
          conv.tags = data.tags;
        }
      });
      this.app.pinConversationView.forEach(conv => {
        if (conv.id == data.id) {
          conv.tags = data.tags;
        }
      });
    },

    typingConversation(data) {
      this.conversations.forEach(conv => {
        if (conv.id == data.conversationId) {
          if (data.type == "typing") {
            conv.lastMessageContent = data.username + " đang soạn tin nhắn ...";
            conv.typing = true;
          } else if (data.type == "stopped_typing") {
            conv.lastMessageContent = data.lastMessageContent;
            conv.typing = false;
          }
        }
      });
    },
    typingConversationPin(data) {
      this.app.pinConversationView.forEach(conv => {
        if (conv.id == data.conversationId) {
          if (data.type == "typing") {
            conv.lastMessageContent = data.username + " đang soạn tin nhắn ...";
            conv.typing = true;
          } else if (data.type == "stopped_typing") {
            conv.lastMessageContent = data.lastMessageContent;
            conv.typing = false;
          }
        }
      });
    },
    hiddenConversation(conversationId) {
      if (this.selectedCon.id == conversationId) {
        this.selectedCon = {};
      }
      var currentIndex = this.conversations.findIndex(csv => {
        return csv.id === conversationId;
      });
      if (currentIndex >= 0) {
        this.conversations.splice(currentIndex, 1);
      }
      currentIndex = this.app.pinConversations.findIndex(csv => {
        return csv.id === conversationId;
      });
      if (currentIndex >= 0) {
        this.app.pinConversations.splice(currentIndex, 1);

      }
      currentIndex = this.app.pinConversationView.findIndex(csv => {
        return csv.id === conversationId;
      });
      if (currentIndex >= 0) {
        this.app.pinConversationView.splice(currentIndex, 1);

      }

    },
    readConversation(data) {
      this.conversations.forEach(conv => {
        if (conv.id == data.id) {
          conv.unreadCount = data.unreadCount;
        }
      });
      if (this.selectedCon.id == data.id) {
        this.selectedCon.unreadCount = data.unreadCount;
        this.$emit("selected", this.selectedCon);
      }
    },
    readConversationPin(data) {
      this.app.pinConversationView.forEach(conv => {
        if (conv.id == data.id) {
          conv.unreadCount = data.unreadCount;
        }
      });
      if (this.selectedCon.id == data.id) {
        this.selectedCon.unreadCount = data.unreadCount;
        this.$emit("selected", this.selectedCon);
      }
    },

    sortConversation() {
      this.loading = false;
      this.viewConversations = [];
      let view = this.conversations;
      let pinView = this.app.pinConversations;
      if (this.filter.filterGroup !== null) {
        view = view.filter(p => p.group == this.isGroup(this.filter.filterGroup));
        pinView = pinView.filter(p => p.group == this.isGroup(this.filter.filterGroup));
      }
      if (this.filter.filterMessage === "Chưa đọc") {
        view = view.filter(p => p.unreadCount > 0);
        pinView = pinView.filter(p => p.unreadCount > 0);
      }
      if (this.filter.filterMessage === "Chưa trả lời") {
        view = view.filter(p => p.unReplied == true);
        pinView = pinView.filter(p => p.unReplied == true);
      }
      if (this.filter.searchKey !== "") {
        view = view.filter(p => p.toName.toLowerCase().includes(this.filter.searchKey.toLowerCase())
          || (p.phone && p.phone.includes(this.subPhone(this.filter.searchKey)))
          || (p.swName && p.swName.toLowerCase().includes(this.filter.searchKey.toLowerCase())));
        pinView = pinView.filter(p => p.toName.toLowerCase().includes(this.filter.searchKey.toLowerCase())
          || (p.phone && p.phone.includes(this.subPhone(this.filter.searchKey)))
          || (p.swName && p.swName.toLowerCase().includes(this.filter.searchKey.toLowerCase())));
      }
      if (this.filter.selectedAccountIds.length > 0) {
        view = view.filter(p => this.checkAcc(p.accountId) == true);
        pinView = pinView.filter(p => this.checkAcc(p.accountId) == true);
      }
      if (this.filter.selectedTags.length > 0) {
        view = view.filter(p => this.checkTags(p.tags) == true);
        pinView = pinView.filter(p => this.checkTags(p.tags) == true);
      }
      view.sort((a, b) => b.lastMessageTime - a.lastMessageTime);
      pinView.sort((a, b) => b.lastMessageTime - a.lastMessageTime);
      this.app.pinConversationView = pinView;
      this.viewConversations = view;
    },
    checkTags(tags) {
      let rt = false;
      if (tags.length > 0) {
        tags.forEach((tag) => {
          let filter = this.filter.selectedTags.filter(t => t == tag.id);
          if (filter && filter.length > 0) {
            rt = true;
          }
        });
      }
      return rt;
    },
    checkAcc(accountId) {
      let filter = this.filter.selectedAccountIds.filter(p => p == accountId);
      if (filter != null && filter.length > 0) {
        return true;
      }
      return false;
    },
    openSearchArea() {
      this.showSearchArea = true;
      this.loadHistorySearch();
    },
    closeSearchArea() {
      this.showSearchArea = false;
      this.searchKey = "";
      this.friendSearch = {};
      this.fetchConversationList();
    },
    searchUniversal() {
      this.historySearch = [];
      const VN_PHONE_REGEX = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
      if (this.searchKey.match(VN_PHONE_REGEX)) {
        this.searchUserByPhone();
      } else {
        this.friendSearch = {};
        this.searchUserLocal();
      }
    },
    loadHistorySearch() {
      let historySearch = localStorage.getItem("history_search");

      if (historySearch) {
        this.historySearch = JSON.parse(historySearch);
      }
    },
    searchUserByPhone() {
      let searchKey = this.searchKey;

      if (this.searchKey.startsWith("0")) searchKey = "+84" + this.searchKey.substring(1);
      this.$http.get("/api/search/byPhone", { params: { searchKey: searchKey } }).then(resp => {
        if (resp.data.error_code == 0) {
          this.friendSearch = resp.data.data;
          this.friendSearch.phone = this.searchKey;

          let item = {
            avatar: this.friendSearch.avatar,
            name: this.friendSearch.display_name,
            uid: this.friendSearch.uid
          };

          this.saveHistory(item);
        }
      });
    },
    saveHistory(item) {
      let historySearch = localStorage.getItem("history_search");
      if (!historySearch) historySearch = new Array();
      else historySearch = JSON.parse(historySearch);

      if (!historySearch.find(i => i.uid == item.uid)) {
        historySearch.push(item);
        localStorage.setItem("history_search", JSON.stringify(historySearch));
      }
    },
    updateConversationTag(updatedConversation) {
      var currentIndex = this.conversations.findIndex(csv => {
        return csv.id === updatedConversation.id;
      });
      if (currentIndex >= 0) {
        this.conversations[currentIndex].tags = updatedConversation.tags;
      }
      this.sortConversation();
    },
    updateConversationTagPin(updatedConversation) {
      var currentIndex = this.app.pinConversationView.findIndex(csv => {
        return csv.id === updatedConversation.id;
      });
      if (currentIndex >= 0) {
        this.app.pinConversationView[currentIndex].tags = updatedConversation.tags;
      }
      this.sortConversation();
    },
    searchUserLocal() {
      this.conversations = [];
      this.showSearchArea = false;
      this.$http.get("/api/conversation/search", { params: { searchKey: this.searchKey } }).then(resp => {
        this.conversations = resp.data;
        this.noMoreConversation = true;
        this.sortConversation();
      });
    },
    openFriendBox(friendSearch) {
      this.friendUid = friendSearch.uid;
      this.friendBoxVisible = true;
    },
    searchNewContact() {
      this.searchNewContactVisible = true;
    },
    hiddenChange(item) {
      this.$http.get("/api/conversation/hidden", {
        params: {
          accountId: item.accountId,
          conversationId: item.id,
          hidden: true
        }
      });
    }
  },
  mounted() {

    this.$bus.$on("leaveGroup", (idConversationGroup) => {
      let index = this.conversations.findIndex(s => s.accountId === idConversationGroup.accountId && s.toId === idConversationGroup.toId);
      if (index === -1) return;
      this.hiddenChange(idConversationGroup);
      this.conversations.splice(index, 1);
      this.$bus.$emit("closeGroupInfoPopup");
      this.$emit("reloadConverastionPage");
    });
  },
  async created() {
    this.selectedCon = { id: { accountId: "", toId: "" } };
    await this.fetchConversationList();
    this.hasLoadMore = true;
  },
  beforeDestroy() {
    this.$bus.$off("leaveGroup");
  }

};
</script>
